import { default as _debounce } from 'lodash.debounce';
import { getApplicationMenuUi, getLoginUi, injectNavigationMenuItem, positionMenuTargetFunc } from '../dom';
import { injectAppSwitcherCss } from '../styles';
import { APP_SWITCHER_TARGET_ID, MENU_DOM_ID, NAV_DOM_ID, NAV_MENU_DOM_TARGET_ID } from '../constants';
import { getLogoutButton, isAuthenticated, logout, menuDomRemover, t } from './state-helpers';
import { DEFAULT_OPTIONS } from './constants';
const stateChartInterfaceFn = (statechart) => {
    statechart.addState('#init', {
        setInitialConfiguration: (options) => {
            const thisState = statechart.getState('#init');
            const mergedOptions = {
                ...DEFAULT_OPTIONS,
                ...options
            };
            // TODO: Switch code to handle static and noLogin paths
            thisState.goToState('#main', { options: mergedOptions });
            if (!mergedOptions?.medalliaConfig) {
                statechart.sendEvent('finishLoading');
            }
        }
    });
    statechart.addState('#main', {
        initialSubstate: '#main.loading',
        enterState: () => {
            // TODO: Show the main dropdown
            const thisState = statechart.getState('#main');
            const options = thisState.getData('options');
            injectAppSwitcherCss(options);
            injectNavigationMenuItem(options, () => {
                statechart.sendEvent('toggleMenu');
            });
        },
        exitState: () => {
            // TODO: remove all the injected code
        },
        updateTranslations: (translations) => {
            const thisState = statechart.getState('#main');
            thisState.setData('translations', translations);
            thisState.goToState('#main.closedMenu');
        },
        serverError: (err) => {
            // TODO: make this go to error state
            // eslint-disable-next-line no-alert
            alert(`SERVER ERROR: ${err}`);
        }
    });
    statechart.addState('#main.loading', {
        parentState: '#main',
        enterState: () => {
            // TODO: show loading div
        },
        exitState: () => {
            // TODO: remove loading div
        },
        finishLoading: () => {
            const thisState = statechart.getState('#main.loading');
            thisState.goToState('#main.closedMenu');
        },
        toggleMenu: () => 
        // we want to block when a click happens in the #main.loading state
        true
    });
    statechart.addState('#main.closedMenu', {
        parentState: '#main',
        toggleMenu: () => {
            const thisState = statechart.getState('#main.closedMenu');
            const options = thisState.getData('options');
            // check to see if we need to go to login
            if (!options.skipLogin && !isAuthenticated()) {
                // should go to login
                thisState.goToState('#main.openedMenu.login');
                return;
            }
            if (options.staticLinks) {
                thisState.goToState('#main.openedMenu.staticLinks');
                return;
            }
            thisState.goToState('#main.openedMenu.loading');
            statechart.sendEvent('successfulLogin');
            statechart.sendEvent('refreshPrograms');
        }
    });
    statechart.addState('#main.openedMenu', {
        parentState: '#main',
        enterState: () => {
            const thisState = statechart.getState('#main.openedMenu');
            const menuTarget = document.createElement('div');
            const options = thisState.getData('options');
            const targetId = options.targetId || APP_SWITCHER_TARGET_ID;
            menuTarget.setAttribute('id', `${NAV_MENU_DOM_TARGET_ID}_${targetId}`);
            const positionMenuTarget = positionMenuTargetFunc(menuTarget, options.targetId);
            window.addEventListener('resize', _debounce(positionMenuTarget, 300));
            positionMenuTarget();
            document.querySelector('body')?.appendChild(menuTarget);
            const translations = thisState.getData('translations');
            const nav = document.createElement('nav');
            nav.setAttribute('id', `${NAV_DOM_ID}_${targetId}`);
            nav.classList.add('app-switcher-nav-wrap');
            nav.classList.add('mas-drop-menu');
            nav.setAttribute('aria-label', t('app_switcher.labels.navigation_drop_menu_aria_label', translations));
            menuTarget.appendChild(nav);
            thisState.setData('navElement', nav);
        },
        exitState: () => {
            const thisState = statechart.getState('#main.openedMenu');
            const options = thisState.getData('options');
            const targetId = options.targetId || APP_SWITCHER_TARGET_ID;
            const menuDom = document.querySelector(`#${NAV_MENU_DOM_TARGET_ID}_${targetId}`);
            // window.removeEventListener('resize', _debounce(positionMenuTarget, 300));
            // Shouldn't have to do this, but types!
            if (menuDom) {
                document.querySelector('body')?.removeChild(menuDom);
            }
        },
        toggleMenu: () => {
            const thisState = statechart.getState('#main.openedMenu');
            thisState.goToState('#main.closedMenu');
        },
        logout: () => {
            const thisState = statechart.getState('#main.openedMenu');
            logout();
            thisState.goToState('#main.closedMenu');
        }
    });
    statechart.addState('#main.openedMenu.loading', {
        parentState: '#main.openedMenu',
        enterState: () => {
            const thisState = statechart.getState('#main.openedMenu.loading');
            const nav = thisState.getData('navElement');
            const menuDomNode = document.createElement('div');
            const options = thisState.getData('options');
            const targetId = options.targetId || APP_SWITCHER_TARGET_ID;
            menuDomNode.setAttribute('id', `${MENU_DOM_ID}_${targetId}`);
            const translations = thisState.getData('translations');
            const loading = document.createElement('div');
            loading.textContent = t('app_switcher.loading', translations);
            menuDomNode.appendChild(loading);
            nav.appendChild(menuDomNode);
        },
        exitState: () => {
            const thisState = statechart.getState('#main.openedMenu.loading');
            menuDomRemover(thisState)();
        },
        updateProgramData: (data) => {
            const thisState = statechart.getState('#main.openedMenu.loading');
            thisState.goToState('#main.openedMenu.programs', { programData: data });
        }
    });
    statechart.addState('#main.openedMenu.login', {
        parentState: '#main.openedMenu',
        enterState: () => {
            const thisState = statechart.getState('#main.openedMenu.login');
            const nav = thisState.getData('navElement');
            const translations = thisState.getData('translations');
            const options = thisState.getData('options');
            const loginContent = getLoginUi(translations, options);
            nav.classList.add('mas-alchemy-default-background');
            nav.appendChild(loginContent);
        },
        exitState: () => {
            const thisState = statechart.getState('#main.openedMenu.login');
            const nav = thisState.getData('navElement');
            nav.classList.remove('mas-alchemy-default-background');
            menuDomRemover(thisState)();
        },
        loginClicked: () => {
            const username = document.querySelector('#app_switcher_login_username')?.value;
            const password = document.querySelector('#app_switcher_login_password')?.value;
            statechart.sendEvent('process_login', username, password);
        },
        successfulLogin: () => {
            const thisState = statechart.getState('#main.openedMenu.login');
            thisState.goToState('#main.openedMenu.loading');
            const options = thisState.getData('options');
            if (options.staticLinks) {
                thisState.goToState('#main.openedMenu.staticLinks');
                return;
            }
            thisState.goToState('#main.openedMenu.loading');
            statechart.sendEvent('refreshPrograms');
        }
    });
    statechart.addState('#main.openedMenu.staticLinks', {
        parentState: '#main.openedMenu',
        enterState: () => {
            const thisState = statechart.getState('#main.openedMenu.staticLinks');
            const nav = thisState.getData('navElement');
            const options = thisState.getData('options');
            const targetId = options.targetId || APP_SWITCHER_TARGET_ID;
            const menuDomNode = document.createElement('div');
            menuDomNode.setAttribute('id', `${MENU_DOM_ID}_${targetId}`);
            menuDomNode.innerHTML = '';
            const menuContent = options.staticLinks && getApplicationMenuUi(options.staticLinks, options.headerText);
            if (menuContent) {
                menuDomNode.appendChild(menuContent);
            }
            nav.appendChild(menuDomNode);
            thisState.setData('menuContent', menuContent);
        },
        exitState: () => {
            const thisState = statechart.getState('#main.openedMenu.programs');
            menuDomRemover(thisState)();
        }
    });
    statechart.addState('#main.openedMenu.programs', {
        parentState: '#main.openedMenu',
        enterState: () => {
            const thisState = statechart.getState('#main.openedMenu.programs');
            const nav = thisState.getData('navElement');
            const options = thisState.getData('options');
            const targetId = options.targetId || APP_SWITCHER_TARGET_ID;
            const translations = thisState.getData('translations');
            const menuDomNode = document.createElement('div');
            menuDomNode.setAttribute('id', `${MENU_DOM_ID}_${targetId}`);
            const programData = thisState.getData('programData');
            menuDomNode.innerHTML = '';
            const menuContent = getApplicationMenuUi(programData?.data, options.headerText);
            const logoutButtonWrap = document.createElement('div');
            logoutButtonWrap.classList.add('mas-logout-button-wrap');
            logoutButtonWrap.appendChild(getLogoutButton(translations));
            menuDomNode.appendChild(menuContent);
            menuDomNode.appendChild(logoutButtonWrap);
            nav.appendChild(menuDomNode);
            thisState.setData('menuContent', menuContent);
        },
        exitState: () => {
            const thisState = statechart.getState('#main.openedMenu.programs');
            menuDomRemover(thisState)();
        },
        updateProgramData: (data) => {
            const thisState = statechart.getState('#main.openedMenu.programs');
            const programData = data || thisState.getData('programData');
            const jsonPlaceholder = thisState.getData('jsonPlaceholder');
            jsonPlaceholder.textContent = JSON.stringify(programData, null, 2);
        }
    });
};
export default stateChartInterfaceFn;
